import { Skeleton } from '@/common/components/ui/skeleton';

export const AccessTabSkeleton = () => (
  <div className="space-y-5 mt-6">
    <div className="grid grid-cols-3 gap-4">
      <Skeleton className="h-[80px] rounded-xl" />
      <Skeleton className="h-[80px] rounded-xl" />
      <Skeleton className="h-[80px] rounded-xl" />
    </div>
    <Skeleton className="h-[350px] rounded-2xl" />
  </div>
);
